import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "absolute rounded-lg inset-0 flex justify-center items-center bg-gray-300",
  "aria-hidden": "true"
}

import { computed } from 'vue';

type Variant = 'primary' | 'secondary' | 'warning' | 'white';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppButton',
  props: {
    disabled: { type: Boolean },
    loading: { type: Boolean },
    variant: {}
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props;



const buttonClass = computed(() => {
    if (props.disabled || props.loading) return 'cursor-default bg-gray-300 text-gray-500';
    const variant = props.variant ?? 'primary';
    return {
        primary: 'bg-primary-800 hover:bg-opacity-70 text-white cursor-pointer',
        secondary: 'bg-primary-500 bg-opacity-80 hover:bg-opacity-50 text-primary-800 cursor-pointer',
        warning: 'bg-red-400 bg-opacity-25 hover:bg-opacity-35 text-red-400 cursor-pointer',
        white: 'bg-white hover:bg-gray-100 text-gray-600 cursor-pointer',
    }[variant];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["app-button relative font-semibold py-4 rounded-lg w-full transition-colors duration-300", buttonClass.value]),
    disabled: __props.disabled || __props.loading,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', $event)))
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            class: "animate-spin h-5 w-5 text-gray-600",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("circle", {
              class: "opacity-25",
              cx: "12",
              cy: "12",
              r: "10",
              stroke: "currentColor",
              "stroke-width": "4"
            }),
            _createElementVNode("path", {
              class: "opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
            })
          ], -1)
        ]))]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})